/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_FormsInputs */

const en_portalframe_forms = /** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forms`)
};

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const ar_portalframe_forms = en_portalframe_forms;

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const he_portalframe_forms = en_portalframe_forms;

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const ur_portalframe_forms = en_portalframe_forms;

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const es_portalframe_forms = en_portalframe_forms;

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const fr_portalframe_forms = en_portalframe_forms;

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const de_portalframe_forms = en_portalframe_forms;

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const pt_portalframe_forms = en_portalframe_forms;

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const hi_portalframe_forms = en_portalframe_forms;

/** @type {(inputs: Portalframe_FormsInputs) => LocalizedString} */
const bn_portalframe_forms = en_portalframe_forms;

/**
* | output |
* | --- |
* | "Forms" |
*
* @param {Portalframe_FormsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_forms = /** @type {((inputs?: Portalframe_FormsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_FormsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_forms(inputs)
	if (locale === "he") return he_portalframe_forms(inputs)
	if (locale === "ur") return ur_portalframe_forms(inputs)
	if (locale === "es") return es_portalframe_forms(inputs)
	if (locale === "fr") return fr_portalframe_forms(inputs)
	if (locale === "de") return de_portalframe_forms(inputs)
	if (locale === "pt") return pt_portalframe_forms(inputs)
	if (locale === "hi") return hi_portalframe_forms(inputs)
	if (locale === "bn") return bn_portalframe_forms(inputs)
	return /** @type {LocalizedString} */ ("Forms")
});